// extracted by mini-css-extract-plugin
export var bodySections = "_5e-8";
export var gray = "_5e-7";
export var green = "_5e-4";
export var iconContainer = "_5e-9";
export var iconWidgetContainer = "_5e-1";
export var phoneIcon = "_5e-2";
export var red = "_5e-5";
export var statusDot = "_5e-3";
export var widgetContainer = "_5e-0";
export var yellow = "_5e-6";